import { render } from "./Parceiro.vue?vue&type=template&id=3493b854&scoped=true"
import script from "./Parceiro.vue?vue&type=script&lang=js"
export * from "./Parceiro.vue?vue&type=script&lang=js"

import "./Parceiro.vue?vue&type=style&index=0&id=3493b854&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3493b854"]])

export default __exports__